import * as yup from "yup";

import {
  createCURTField,
  createEmpresaField,
  createHabilitacionMunicipalField,
  createDomicilioField,
  createAccesoSecundarioField,
  createZonaEmplazamientoField,
  createUbicacionField,
  createCorreoElectronicoField,
  createTelefonoField,
  createWebField,
  createRepresentanteLegalField,
  createRepresentanteTecnicoField,
  createActividadPrincipalField,
  createActividadSecundariaField,
  createDescripcionActividadField,
  createConEfluentesLiquidosField,
  createConResiduosSolidosUrbanosField,
  createConResiduosPeligrososField,
  createConResiduosPatogenicosField,
  createConEmisionesGaseosasField,
  createConEquiposPCBField,
  createNivelComplejidadAmbiental,
  createConRiesgoExplosionFiel,
  createConRiesgoIncendioField,
  createConRiesgoRuidosField,
  createConRiesgoSustanciasQuimicasField,
  createConSitiosContaminadosField,
  createConFreatimetrosField,
  createConRemediacionesActivasField,
  createRemediacionesField,
  createConCertificadoAptitudAmbientalField,
  createConTramiteCertificadoAptitudAmbientalField,
  createCertificadoAptitudAmbientalField,
  createConCertificadoISO14001Field,
  createConSeguroAmbientalField,
  createSeguroAmbientalField,
  createConEstacionalidadField,
  createMesesProduccionField,
  createOperacionesUnitariasField,
  createProductosElaboradosField,
  createProcesoProductivoField,
  createConQuimicosAuxiliaresField,
  createConQuimicosProduccion,
  createSustanciasQuimicasField,
  createPersonalField,
  createRegimenLaboralField,
  createSuperficieTotalField,
  createSuperficieProduccionField,
  createConConexionCloacasField,
  createConPozoAbsorbente,
  createConsumoElectricidadField,
  createConsumoGasNaturalField,
  createPotenciaActivaField,
  createConEnergiaAlternativaField,
  createFuenteEnergiaAlternativaField,
  createConsumoEnergiaAlternativaField,
  createConCaptacionAguaRedField,
  createConCaptacionAguaSubterraneaField,
  createConCaptacionAguaSuperficialField,
  createConAprovechamientoPluvialesField,
  createConexionRedAguaField,
  createPozosAguaSubterraneaField,
  createTomasAguaSuperficialField,
  createConReusoAguaField,
  createAprovechamientoPluvialesField,
  createReusoAguaField,
  createFuentesEfluentesLiquidosField,
  createTratamientoIndividualField,
  createPlantasTratamientoField,
  createCaracterizacionEfluenteCrudoField,
  createLineasVertidoField,
  createConTratamientoExternoField,
  createTratamientosExternosField,
  createReusoTratamientoField,
  createResiduosTratamientoField,
  createConTratamientoRSUInternoField,
  createEsGeneradorRSUEspecialesField,
  createRegistroRSUEspecialesField,
  createDisponeRSUCEAMSEField,
  createRegistroAltaCEAMSEField,
  createDisposicionRSU,
  createDisposicionCertificadosRSU,
  createTratamientoRSU,
  createResiduosSolidosUrbanosField,
  createRegistroResiduosPeligrososField,
  createResiduosPeligrososField,
  createCategoriaAmbiental,
  createRegistroResiduosPatogenicosField,
  createResiduosPatogenicosField,
  createRegistroEquiposPCBField,
  createCertificadoLibrePCB,
  createConRegistroEmisionesGaseosasField,
  createRegistroEmisionesGaseosasField,
  createConMonitoreoAireField,
  createMonitoreoAireField,
  createConEmisionesCombustionHidrocarburosField,
  createConEmisionesOtrosGasesField,
  createConChimeneasField,
  createChimeneasField,
  createConEvaporacionLiquidosField,
  createConMovimientoLiquidosField,
  createConAcopioLiquidosField,
  createTanquesAcopioLiquidosField,
  createConSublimacionSolidosField,
  createConSolidosGranularesField,
  createConAcopioSolidosGranelField,
  createConAcopioSolidos1000m2Field,
  createAreasAcopioSolidosField,
  createAdjuntosField,
  createConEmisionesComponentesNaturalesField,
} from "../utils/data";

export const TramiteSchema = yup.object().shape({
  numero: yup
    .string()
    .max(14, "errors.tramite.numero.max")
    .required("errors.tramite.numero.required")
    .default(null),
  establecimiento: yup.object().optional().nullable().default(null),
  tipo: yup.object().required().default({ codigo: null, nombre: null }),
  estado: yup.object().required().default({ codigo: null, nombre: null }),
  CURT: yup.string().when(["tipo"], createCURTField),
  empresa: yup.object().when(["tipo", "$action"], createEmpresaField),
  habilitacionMunicipal: yup
    .string()
    .when(["tipo"], createHabilitacionMunicipalField),
  domicilio: yup.object().when(["tipo", "$action"], createDomicilioField),
  accesoSecundario: yup.string().when(["tipo"], createAccesoSecundarioField),
  zonaEmplazamiento: yup.object().when(["tipo"], createZonaEmplazamientoField),
  ubicacion: yup.object().when(["tipo"], createUbicacionField),
  correoElectronico: yup.string().when(["tipo"], createCorreoElectronicoField),
  telefono: yup.string().when(["tipo"], createTelefonoField),
  web: yup.string().when(["tipo"], createWebField),
  representanteLegal: yup
    .object()
    .when(["tipo", "$action"], createRepresentanteLegalField),
  representanteTecnico: yup
    .object()
    .when(["tipo", "$action"], createRepresentanteTecnicoField),
  actividadPrincipal: yup
    .object()
    .when(["tipo"], createActividadPrincipalField),
  actividadSecundaria: yup
    .object()
    .when(["tipo"], createActividadSecundariaField),
  descripcionActividad: yup
    .string()
    .when(["tipo"], createDescripcionActividadField),
  conEfluentesLiquidos: yup
    .boolean()
    .when(["tipo"], createConEfluentesLiquidosField),
  conResiduosSolidosUrbanos: yup
    .boolean()
    .when(["tipo"], createConResiduosSolidosUrbanosField),
  conResiduosPeligrosos: yup
    .boolean()
    .when(["tipo"], createConResiduosPeligrososField),
  conResiduosPatogenicos: yup
    .boolean()
    .when(["tipo"], createConResiduosPatogenicosField),
  conEmisionesGaseosas: yup
    .boolean()
    .when(["tipo"], createConEmisionesGaseosasField),
  conEquiposPCB: yup.boolean().when(["tipo"], createConEquiposPCBField),
  categoriaAmbiental: yup.object().when(["tipo"], createCategoriaAmbiental),
  nivelComplejidadAmbiental: yup
    .number()
    .when(["tipo", "categoriaAmbiental"], createNivelComplejidadAmbiental),
  conRiesgoExplosion: yup
    .boolean()
    .when(["tipo"], createConRiesgoExplosionFiel),
  conRiesgoIncendio: yup.boolean().when(["tipo"], createConRiesgoIncendioField),
  conRiesgoRuidos: yup.boolean().when(["tipo"], createConRiesgoRuidosField),
  conRiesgoSustanciasQuimicas: yup
    .boolean()
    .when(["tipo"], createConRiesgoSustanciasQuimicasField),
  conSitiosContaminados: yup
    .boolean()
    .when(["tipo"], createConSitiosContaminadosField),
  conFreatimetros: yup.boolean().when(["tipo"], createConFreatimetrosField),
  conRemediacionesActivas: yup
    .boolean()
    .when(["tipo"], createConRemediacionesActivasField),
  remediaciones: yup
    .object()
    .when(["tipo", "conRemediaciones"], createRemediacionesField),
  conCertificadoAptitudAmbiental: yup
    .boolean()
    .when(["tipo"], createConCertificadoAptitudAmbientalField),
  conTramiteCertificadoAptitudAmbiental: yup
    .boolean()
    .when(["tipo"], createConTramiteCertificadoAptitudAmbientalField),
  certificadoAptitudAmbiental: yup
    .object()
    .when(
      ["tipo", "conCertificadoAptitudAmbiental", "$action"],
      createCertificadoAptitudAmbientalField,
    ),
  conCertificadoISO14001: yup
    .boolean()
    .when(["tipo"], createConCertificadoISO14001Field),
  conSeguroAmbiental: yup
    .boolean()
    .when(["tipo"], createConSeguroAmbientalField),
  seguroAmbiental: yup
    .object()
    .when(
      ["tipo", "conSeguroAmbiental", "$action"],
      createSeguroAmbientalField,
    ),
  conEstacionalidad: yup.boolean().when(["tipo"], createConEstacionalidadField),
  mesesProduccion: yup
    .array()
    .when(["tipo", "conEstacionalidad"], createMesesProduccionField),
  operacionesUnitarias: yup
    .array()
    .when(["tipo"], createOperacionesUnitariasField),
  productosElaborados: yup
    .array()
    .when(["tipo", "actividadPrincipal"], createProductosElaboradosField),
  procesoProductivo: yup.string().when(["tipo"], createProcesoProductivoField),
  conQuimicosAuxiliares: yup
    .boolean()
    .when(["tipo"], createConQuimicosAuxiliaresField),
  conQuimicosProduccion: yup
    .boolean()
    .when(["tipo"], createConQuimicosProduccion),
  sustanciasQuimicas: yup.array().when(["tipo"], createSustanciasQuimicasField),
  personal: yup.number().when(["tipo"], createPersonalField),
  regimenLaboral: yup.array().when(["tipo"], createRegimenLaboralField),
  superficieTotal: yup.object().when(["tipo"], createSuperficieTotalField),
  superficieProduccion: yup
    .object()
    .when(["tipo"], createSuperficieProduccionField),
  conConexionCloacas: yup
    .boolean()
    .when(["tipo"], createConConexionCloacasField),
  conPozoAbsorbente: yup.boolean().when(["tipo"], createConPozoAbsorbente),
  consumoElectricidad: yup
    .object()
    .when(["tipo"], createConsumoElectricidadField),
  consumoGasNatural: yup.object().when(["tipo"], createConsumoGasNaturalField),
  potenciaActiva: yup.object().when(["tipo"], createPotenciaActivaField),
  conEnergiaAlternativa: yup
    .boolean()
    .when(["tipo"], createConEnergiaAlternativaField),
  fuenteEnergiaAlternativa: yup
    .string()
    .when(
      ["tipo", "conEnergiaAlternativa", "$action"],
      createFuenteEnergiaAlternativaField,
    ),
  consumoEnergiaAlternativa: yup
    .object()
    .when(
      ["tipo", "conEnergiaAlternativa", "$action"],
      createConsumoEnergiaAlternativaField,
    ),
  conCaptacionAguaRed: yup
    .boolean()
    .when(["tipo"], createConCaptacionAguaRedField),
  conCaptacionAguaSubterranea: yup
    .boolean()
    .when(["tipo"], createConCaptacionAguaSubterraneaField),
  conCaptacionAguaSuperficial: yup
    .boolean()
    .when(["tipo"], createConCaptacionAguaSuperficialField),
  conAprovechamientoPluviales: yup
    .boolean()
    .when(["tipo"], createConAprovechamientoPluvialesField),
  conReusoAgua: yup.boolean().when(["tipo"], createConReusoAguaField),
  conexionRedAgua: yup
    .object()
    .when(
      ["tipo", "conCaptacionAguaRed", "$action"],
      createConexionRedAguaField,
    ),
  pozosAguaSubterranea: yup
    .array()
    .when(
      ["tipo", "conCaptacionAguaSubterranea"],
      createPozosAguaSubterraneaField,
    ),
  tomasAguaSuperficial: yup
    .array()
    .when(
      ["tipo", "conCaptacionAguaSuperficial"],
      createTomasAguaSuperficialField,
    ),
  aprovechamientoPluviales: yup
    .object()
    .when(
      ["tipo", "conAprovechamientoPluviales", "$action"],
      createAprovechamientoPluvialesField,
    ),
  reusoAgua: yup
    .object()
    .when(["tipo", "conReusoAgua", "$action"], createReusoAguaField),
  fuentesEfluentesLiquidos: yup
    .array()
    .when(
      ["tipo", "conEfluentesLiquidos"],
      createFuentesEfluentesLiquidosField,
    ),
  tratamientoIndividual: yup
    .object()
    .when(
      [
        "tipo",
        "conEfluentesLiquidos",
        "actividadPrincipal",
        "actividadSecundaria",
        "establecimiento",
      ],
      createTratamientoIndividualField,
    ),
  plantasTratamiento: yup
    .array()
    .when(["tipo", "conEfluentesLiquidos"], createPlantasTratamientoField),
  caracterizacionEfluenteCrudo: yup
    .array()
    .when(
      ["tipo", "conEfluentesLiquidos", "plantasTratamiento"],
      createCaracterizacionEfluenteCrudoField,
    ),
  lineasVertido: yup
    .array()
    .when(
      ["tipo", "conEfluentesLiquidos", "conTratamientoExterno"],
      createLineasVertidoField,
    ),
  conTratamientoExterno: yup
    .boolean()
    .when(["tipo"], createConTratamientoExternoField),
  tratamientosExternos: yup
    .array()
    .when(
      ["tipo", "conEfluentesLiquidos", "conTratamientoExterno"],
      createTratamientosExternosField,
    ),
  reusoTratamiento: yup
    .object()
    .when(["tipo", "conEfluentesLiquidos"], createReusoTratamientoField),
  residuosTratamiento: yup
    .array()
    .when(
      ["tipo", "conEfluentesLiquidos", "plantasTratamiento"],
      createResiduosTratamientoField,
    ),
  conTratamientoRSUInterno: yup
    .boolean()
    .when(
      ["tipo", "conResiduosSolidosUrbanos", "establecimiento"],
      createConTratamientoRSUInternoField,
    ),
  esGeneradorRSUEspeciales: yup
    .boolean()
    .when(
      ["tipo", "conResiduosSolidosUrbanos", "establecimiento"],
      createEsGeneradorRSUEspecialesField,
    ),
  registroRSUEspeciales: yup
    .string()
    .when(
      [
        "tipo",
        "conResiduosSolidosUrbanos",
        "esGeneradorRSUEspeciales",
        "establecimiento",
      ],
      createRegistroRSUEspecialesField,
    ),
  disponeRSUCEAMSE: yup
    .boolean()
    .when(
      ["tipo", "conResiduosSolidosUrbanos", "establecimiento"],
      createDisponeRSUCEAMSEField,
    ),
  registroAltaCEAMSE: yup
    .string()
    .when(
      [
        "tipo",
        "conResiduosSolidosUrbanos",
        "disponeRSUCEAMSE",
        "establecimiento",
      ],
      createRegistroAltaCEAMSEField,
    ),
  disposicionRSU: yup
    .string()
    .when(
      [
        "tipo",
        "conResiduosSolidosUrbanos",
        "disponeRSUCEAMSE",
        "establecimiento",
      ],
      createDisposicionRSU,
    ),
  disposicionCertificadosRSU: yup
    .string()
    .when(
      [
        "tipo",
        "conResiduosSolidosUrbanos",
        "disponeRSUCEAMSE",
        "domicilio",
        "establecimiento",
      ],
      createDisposicionCertificadosRSU,
    ),
  tratamientosRSU: yup
    .array()
    .when(
      [
        "tipo",
        "conResiduosSolidosUrbanos",
        "conTratamientoRSUInterno",
        "establecimiento",
      ],
      createTratamientoRSU,
    ),
  residuosSolidosUrbanos: yup
    .array()
    .when(
      ["tipo", "conResiduosSolidosUrbanos", "establecimiento"],
      createResiduosSolidosUrbanosField,
    ),
  registroResiduosPeligrosos: yup
    .string()
    .when(
      ["tipo", "conResiduosPeligrosos", "establecimiento"],
      createRegistroResiduosPeligrososField,
    ),
  residuosPeligrosos: yup
    .array()
    .when(
      ["tipo", "conResiduosPeligrosos", "establecimiento"],
      createResiduosPeligrososField,
    ),
  registroResiduosPatogenicos: yup
    .string()
    .when(
      ["tipo", "conResiduosPatogenicos", "establecimiento"],
      createRegistroResiduosPatogenicosField,
    ),
  residuosPatogenicos: yup
    .array()
    .when(
      ["tipo", "conResiduosPatogenicos", "establecimiento"],
      createResiduosPatogenicosField,
    ),
  registroEquiposPCB: yup
    .string()
    .when(
      ["tipo", "conEquiposPCB", "establecimiento"],
      createRegistroEquiposPCBField,
    ),
  conCertificadoLibrePCB: yup
    .boolean()
    .when(
      ["tipo", "conEquiposPCB", "establecimiento"],
      createCertificadoLibrePCB,
    ),
  conRegistroEmisionesGaseosas: yup
    .boolean()
    .when(
      ["tipo", "conEmisionesGaseosas"],
      createConRegistroEmisionesGaseosasField,
    ),
  registroEmisionesGaseosas: yup
    .string()
    .when(
      ["tipo", "conEmisionesGaseosas", "conRegistroEmisionesGaseosas"],
      createRegistroEmisionesGaseosasField,
    ),
  conMonitoreoAire: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConMonitoreoAireField),
  monitoreoAire: yup
    .object()
    .when(
      ["tipo", "conEmisionesGaseosas", "conMonitoreoAire"],
      createMonitoreoAireField,
    ),
  conEmisionesComponentesNaturales: yup
    .boolean()
    .when(
      ["tipo", "conEmisionesGaseosas", "$action"],
      createConEmisionesComponentesNaturalesField,
    ),
  conEmisionesCombustionHidrocarburos: yup
    .boolean()
    .when(
      ["tipo", "conEmisionesGaseosas", "$action"],
      createConEmisionesCombustionHidrocarburosField,
    ),
  conEmisionesOtrosGases: yup
    .boolean()
    .when(
      ["tipo", "conEmisionesGaseosas", "$action"],
      createConEmisionesOtrosGasesField,
    ),
  conChimeneas: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConChimeneasField),
  chimeneas: yup
    .array()
    .when(
      ["tipo", "conEmisionesGaseosas", "conChimeneas"],
      createChimeneasField,
    ),
  conEvaporacionLiquidos: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConEvaporacionLiquidosField),
  conMovimientoLiquidos: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConMovimientoLiquidosField),
  conAcopioLiquidos: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConAcopioLiquidosField),
  tanquesAcopioLiquidos: yup
    .array()
    .when(
      ["tipo", "conEmisionesGaseosas", "conAcopioLiquidos"],
      createTanquesAcopioLiquidosField,
    ),
  conSublimacionSolidos: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConSublimacionSolidosField),
  conSolidosGranulares: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConSolidosGranularesField),
  conAcopioSolidosGranel: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConAcopioSolidosGranelField),
  conAcopioSolidos1000m2: yup
    .boolean()
    .when(["tipo", "conEmisionesGaseosas"], createConAcopioSolidos1000m2Field),
  areasAcopioSolidos: yup
    .array()
    .when(
      [
        "tipo",
        "conEmisionesGaseosas",
        "conSolidosGranulares",
        "conSublimacionSolidos",
        "conAcopioSolidosGranel",
      ],
      createAreasAcopioSolidosField,
    ),
  adjuntos: yup.array().when(["tipo", "estado"], createAdjuntosField),
});
